export function renderVideo(ctx, shape, ptScale) {
    const x = shape.position.x * ptScale;
    const y = shape.position.y * ptScale;
    const width = shape.size.width * ptScale;
    const height = shape.size.height * ptScale;
    ctx.fillStyle = '#000000';
    ctx.fillRect(x, y, width, height);
    ctx.strokeStyle = '#666666';
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, width, height);
    const centerX = x + width / 2;
    const centerY = y + height / 2;
    const iconSize = Math.min(width, height) * 0.2;
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.moveTo(centerX - iconSize / 2, centerY - iconSize);
    ctx.lineTo(centerX - iconSize / 2, centerY + iconSize);
    ctx.lineTo(centerX + iconSize, centerY);
    ctx.closePath();
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.font = `${14 * ptScale}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText('Video', centerX, y + height - 30 * ptScale);
}
export function renderAudio(ctx, shape, ptScale) {
    const x = shape.position.x * ptScale;
    const y = shape.position.y * ptScale;
    const width = shape.size.width * ptScale;
    const height = shape.size.height * ptScale;
    const gradient = ctx.createLinearGradient(x, y, x, y + height);
    gradient.addColorStop(0, '#667eea');
    gradient.addColorStop(1, '#764ba2');
    ctx.fillStyle = gradient;
    ctx.fillRect(x, y, width, height);
    ctx.strokeStyle = '#5a67d8';
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, width, height);
    const centerX = x + width / 2;
    const centerY = y + height / 2;
    const iconSize = Math.min(width, height) * 0.15;
    ctx.fillStyle = '#ffffff';
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.fillRect(centerX - iconSize, centerY - iconSize / 2, iconSize, iconSize);
    ctx.beginPath();
    ctx.moveTo(centerX, centerY - iconSize / 2);
    ctx.lineTo(centerX + iconSize / 2, centerY - iconSize);
    ctx.lineTo(centerX + iconSize / 2, centerY + iconSize);
    ctx.lineTo(centerX, centerY + iconSize / 2);
    ctx.closePath();
    ctx.fill();
    for (let i = 1; i <= 3; i++) {
        ctx.beginPath();
        ctx.arc(centerX + iconSize, centerY, iconSize * i * 0.5, -Math.PI / 4, Math.PI / 4);
        ctx.stroke();
    }
    ctx.fillStyle = '#ffffff';
    ctx.font = `${14 * ptScale}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText('Audio', centerX, y + height - 30 * ptScale);
}
//# sourceMappingURL=video.js.map